import Vue from "vue";
import VueRouter from "vue-router";
import axios from "../plugins/axios";
import { i18n } from "../plugins/vue-i18n";

import Main from "../pages/client/Main.vue";
import { BoardRoutes } from "./board.router";
import { QuestionRoutes } from "./question.router";

Vue.use(VueRouter);

const routes = [
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 사용자 페이지 라우트
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        // Main 페이지
        path: "/",
        component: Main,
    },
    {
        // 국문 Main 페이지
        path: "/ko",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/Main.vue"),
    },
    {
        // Company - History
        path: "/company/history",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/company/CompanyHistoryPage.vue"),
        props: true,
    },
    {
        // Company - Vision
        path: "/company/vision",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/company/CompanyVisionPage.vue"),
        props: true,
    },
    {
        // Product - Organic Line
        path: "/product/organic",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/product/ProductOrganicPage.vue"),
        props: true,
    },
    {
        // Product - High Function Sports Line
        path: "/product/sports",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/product/ProductSportsPage.vue"),
        props: true,
    },
    {
        // Product - Active & Legging Line
        path: "/product/active",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/product/ProductActivePage.vue"),
        props: true,
    },
    {
        // Product - Cotton & Basic Line
        path: "/product/cotton",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/product/ProductCottonPage.vue"),
        props: true,
    },
    {
        // Product - Fleece & Sherpa Line
        path: "/product/fleece",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/product/ProductFleecePage.vue"),
        props: true,
    },
    {
        // Product - Novelty Line
        path: "/product/novelty",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/product/ProductNoveltyPage.vue"),
        props: true,
    },
    {
        // Product - Comfortable Line
        path: "/product/comfortable",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/product/ProductComfortablePage.vue"),
        props: true,
    },
    {
        // Facilities - China
        path: "/facilities/China",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/facilities/FacilitiesChinaPage.vue"),
        props: true,
    },
    {
        // Facilities - Vietnam
        path: "/facilities/Vietnam",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/facilities/FacilitiesVietnamPage.vue"),
        props: true,
    },
    {
        // Mei Story
        path: "/story",
        component: () => import(/* webpackChunkName: "board" */ "../pages/client/board/StoryPage.vue"),
        props: true,
    },
    {
        // Mei Story
        path: "/story/:_board",
        component: () => import(/* webpackChunkName: "board" */ "../pages/client/board/StoryPage.vue"),
        props: true,
    },
    {
        // Contact Us
        path: "/contact",
        component: () => import(/* webpackChunkName: "form" */ "../pages/client/form/ContactUsPage.vue"),
        props: true,
    },


    ////////////////////////////////////////////////////////////////////////////

    {
        // 국문 Company - History
        path: "/ko/company/history",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/company/CompanyHistoryPage.vue"),
        props: true,
    },
    {
        // 국문 Company - Vision
        path: "/ko/company/vision",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/company/CompanyVisionPage.vue"),
        props: true,
    },
    {
        // 국문 Product - Organic Line
        path: "/ko/product/organic",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/product/ProductOrganicPage.vue"),
        props: true,
    },
    {
        // 국문 Product - High Function Sports Line
        path: "/ko/product/sports",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/product/ProductSportsPage.vue"),
        props: true,
    },
    {
        // 국문 Product - Active & Legging Line
        path: "/ko/product/active",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/product/ProductActivePage.vue"),
        props: true,
    },
    {
        // 국문 Product - Cotton & Basic Line
        path: "/ko/product/cotton",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/product/ProductCottonPage.vue"),
        props: true,
    },
    {
        // 국문 Product - Fleece & Sherpa Line
        path: "/ko/product/fleece",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/product/ProductFleecePage.vue"),
        props: true,
    },
    {
        // 국문 Product - Novelty Line
        path: "/ko/product/novelty",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/product/ProductNoveltyPage.vue"),
        props: true,
    },
    {
        // 국문 Product - Comfortable Line
        path: "/ko/product/comfortable",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/product/ProductComfortablePage.vue"),
        props: true,
    },
    {
        // 국문 Facilities - China
        path: "/ko/facilities/China",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/facilities/FacilitiesChinaPage.vue"),
        props: true,
    },
    {
        // 국문 Facilities - Vietnam
        path: "/ko/facilities/Vietnam",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/facilities/FacilitiesVietnamPage.vue"),
        props: true,
    },
    {
        // 국문 Mei Story
        path: "/ko/story",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/board/StoryPage.vue"),
        props: true,
    },
    {
        // 국문 Mei Story
        path: "/ko/story/:_board",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/board/StoryPage.vue"),
        props: true,
    },
    {
        // 국문 Contact Us
        path: "/ko/contact",
        component: () => import(/* webpackChunkName: "form" */ "../pages/client/ko/form/ContactUsPage.vue"),
        props: true,
    },
    // {
    //     path: "/common/kcp/cert/request",
    //     component: () => import("../pages/common/kcp/KCPCertRequest.vue"),
    //     props: true,
    // },
    // {
    //     path: "/common/kcp/cert/response",
    //     component: () => import("../pages/common/kcp/KCPCertResponse.vue"),
    //     props: true,
    // },
    {
        // 가이드
        path: "/guide",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/Guide.vue"),
        props: true,
    },
    // {
    //     // 로그인
    //     path: "/login",
    //     component: () => import(/* webpackChunkName: "login" */ "../pages/client/login/main.vue"),
    //     props: true,
    // },
    // {
    //     // 비밀번호 찾기
    //     path: "/login/find-password",
    //     component: () => import(/* webpackChunkName: "login" */ "../pages/client/login/find-password.vue"),
    //     props: true,
    // },
    // {
    //     // 아이디 찾기
    //     path: "/login/find-id",
    //     component: () => import(/* webpackChunkName: "login" */ "../pages/client/login/find-id.vue"),
    //     props: true,
    // },
    // {
    //     // 회원가입
    //     path: "/join",
    //     component: () => import(/* webpackChunkName: "join" */ "../pages/client/join/main.vue"),
    //     props: true,
    // },
    // {
    //     // 회원가입 폼
    //     path: "/join/type",
    //     component: () => import(/* webpackChunkName: "join" */ "../pages/client/join/type.vue"),
    //     props: true,
    // },
    // {
    //     // 회원가입 폼
    //     path: "/join/form",
    //     component: () => import(/* webpackChunkName: "join" */ "../pages/client/join/form.vue"),
    //     props: true,
    // },
    // {
    //     // 회원가입 완료
    //     path: "/join/complete",
    //     component: () => import(/* webpackChunkName: "join" */ "../pages/client/join/complete.vue"),
    //     props: true,
    // },
    // {
    //     // 1:1 문의
    //     path: "/mypage/question",
    //     component: () => import(/* webpackChunkName: "question" */ "../pages/client/mypage/question.vue"),
    //     children: [...QuestionRoutes],
    //     props: true,
    // },
    // {
    //     // 회원 정보 상세
    //     path: "/mypage/myinfo",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/myinfo.vue"),
    //     props: true,
    // },
    // {
    //     // 회원 정보 변경
    //     path: "/mypage/myinfo/:tab",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/myinfo.vue"),
    //     props: true,
    // },
    // {
    //     // 회원 탈퇴
    //     path: "/mypage/leave",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/leave.vue"),
    //     props: true,
    // },
    // {
    //     // 회원 탈퇴
    //     path: "/mypage/leave/:tab",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/leave.vue"),
    //     props: true,
    // },
    // {
    //     // 공지사항
    //     path: "/center/notice",
    //     component: () => import(/* webpackChunkName: "center" */ "../pages/client/center/notice.vue"),
    //     props: true,
    // },
    // {
    //     // 공지사항
    //     path: "/center/notice/:_notification",
    //     component: () => import(/* webpackChunkName: "center" */ "../pages/client/center/notice.vue"),
    //     props: true,
    // },
    // {
    //     // 서비스이용약관
    //     path: "/service-policy",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/center/ServicePolicyPage.vue"),
    //     props: true,
    // },
    // {
    //     // 개인정보처리방침
    //     path: "/privacy-policy",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/center/PrivacyPolicyPage.vue"),
    //     props: true,
    // },
    // {
    //     // 문의 및 제휴
    //     path: "/form/inquiry-partner",
    //     component: () => import(/* webpackChunkName: "form" */ "../pages/client/form/InquiryPartner.vue"),
    //     props: true,
    // },

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 관리자 페이지 라우트
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        // 관리자 메인
        path: "/console",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/Main.vue"),
        props: true,
        scope: ["root", "console"],
    },
    {
        // 관리자 메인
        path: "/console/brand",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/Partner.vue"),
        props: true,
        scope: ["root", "console"],
    },
    {
        // 관리자 - 대시보드
        path: "/console/dashboard",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/Dashboard.vue"),
        props: true,
    },
    // {
    //     // 관리자 - 옥션 프로그램
    //     path: "/console/auction-programs",
    //     component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/auction/ProgramListPage.vue"),
    //     props: true,
    //     scope: ["console"],
    // },
    // {
    //     // 관리자 - 옥션 작품
    //     path: "/console/auction-works",
    //     component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/auction/WorkListPage.vue"),
    //     props: true,
    //     scope: ["console"],
    // },
    // {
    //     // 관리자 - 옥션 작가
    //     path: "/console/auction-authors",
    //     component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/auction/AuthorListPage.vue"),
    //     props: true,
    //     scope: ["console"],
    // },
    {
        // 관리자 - 게시판관리
        path: "/console/boards",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/board/BoardList.vue"),
    },
    {
        // 관리자 - 게시판관리
        path: "/console/boards/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/board/BoardView.vue"),
    },
    {
        // 관리자 - 게시판관리
        path: "/console/boards/:_board",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/board/BoardView.vue"),
    },
    {
        // 관리자 - 폼메일관리
        path: "/console/forms",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/form/FormList.vue"),
    },
    {
        // 관리자 - 폼메일관리
        path: "/console/forms/:_form",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/form/FormView.vue"),
    },
    {
        // 관리자 - 회원등급
        path: "/console/users/levels",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/LevelList.vue"),
        props: true,
    },
    {
        // 관리자 - 회원등급
        path: "/console/users/withdrawals",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/WithdrawalList.vue"),
        props: true,
    },
    {
        // 관리자 - 사용자
        path: "/console/users",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/UserList.vue"),
        props: true,
    },
    {
        // 관리자 - 사용자
        path: "/console/users/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/UserView.vue"),
        props: true,
    },
    {
        // 관리자 - 사용자
        path: "/console/users/:_user",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/UserView.vue"),
        props: true,
    },
    // {
    //     // 관리자 - 공지사항
    //     path: "/console/center/notifications",
    //     component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/center/Notification.vue"),
    //     props: true,
    // },
    // {
    //     // 관리자 - FAQ
    //     path: "/console/center/faqs",
    //     component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/center/Faq.vue"),
    //     props: true,
    // },
    // {
    //     // 관리자 - 1:1문의
    //     path: "/console/center/questions",
    //     component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/center/Question.vue"),
    //     props: true,
    // },

    {
        // 관리자 - 상품관리
        path: "/console/shop/products",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/ProductList.vue"),
        props: true,
    },
    {
        // 관리자 - 상품 생성
        path: "/console/shop/products/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/ProductView.vue"),
        props: true,
    },
    {
        // 관리자 - 상품 복사
        path: "/console/shop/products/copy",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/ProductView.vue"),
        props: true,
    },
    {
        // 관리자 - 상품 view
        path: "/console/shop/products/:_product",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/ProductView.vue"),
        props: true,
    },
    {
        // 관리자 - 카테고리
        path: "/console/shop/categories",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/CategoryList.vue"),
        props: true,
    },

    // {
    //     // 관리자 - 서비스 이용약관
    //     path: "/console/terms",
    //     component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/terms/TermsList.vue"),
    //     props: true,
    // },
    // {
    //     // 관리자 - 배너
    //     path: "/console/banners",
    //     component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/banner/BannerList.vue"),
    //     props: true,
    // },
    // {
    //     // 관리자 - 배너
    //     path: "/console/banners/create",
    //     component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/banner/BannerView.vue"),
    //     props: true,
    // },
    {
        // 관리자 - 배너
        path: "/console/banners/:_banner",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/banner/BannerView.vue"),
        props: true,
    },
    {
        // 관리자 - 팝업
        path: "/console/popups",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/popup/PopupList.vue"),
        props: true,
    },
    {
        // 관리자 - 설정
        path: "/console/setting",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/setting/SettingView.vue"),
        props: true,
    },
    {
        // 관리자 - 비밀번호
        path: "/console/password",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/setting/PasswordView.vue"),
        props: true,
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,

    scrollBehavior: (to, from, savedPosition) => {
        let scrollTo = undefined;

        if (to.hash) {
            scrollTo = to.hash;
        } else if (savedPosition) {
            scrollTo = savedPosition.y;
        }

        if (scrollTo != undefined)
            return {
                selector: scrollTo,
                behavior: "smooth",
            };
    },
});

router.beforeEach((to, from, next) => {
    axios.defaults.headers.common["Authorization"] = sessionStorage.getItem("accessToken") ? `Bearer ${sessionStorage.getItem("accessToken")}` : "";
    axios.defaults.headers.common["Accept-Language"] = i18n.locale;

    next();
});

export default router;
